import {startNodeBlueprint} from "@/pages/workflow/NodeTypes/Blueprints";
import {createNode} from "@/pages/workflow/NodeTypes/WorkflowNode";
import {WorkflowNodeTypes} from "@/types/node";
import {getNodesByType, syncNodeActions} from "@/utils/index";
import {Edge, Node} from "@xyflow/react";

// Helper functions
const deepClone = (node: Node) => {
  return JSON.parse(JSON.stringify(node));
};

const cleanDuplicateIds = (set: any) => {
  return set.filter(
    (item, index, self) => index === self.findIndex(t => t.id === item.id),
  );
};

// Migrations
const migration_1 = (nodes: Node[], edges: Edge[]) => {
  // Set node position to 0,0
  nodes.forEach(node => {
    node.position = {x: 0, y: 0};
  });

  const startNode = getNodesByType(nodes, WorkflowNodeTypes.START)[0];
  const globalNode = getNodesByType(nodes, WorkflowNodeTypes.GLOBAL);
  if (globalNode.length > 0) {
    return {nodes, edges};
  }

  if (startNode) {
    const globalNode = deepClone(startNode);
    const scriptedGreeting = startNode.data.settings["scripted_greeting"];

    globalNode.type = WorkflowNodeTypes.GLOBAL;
    globalNode.data.type = WorkflowNodeTypes.GLOBAL;
    globalNode.id = startNode.id;
    globalNode.selected = false;

    delete startNode.data.settings["global_instructions"];

    nodes = nodes.filter(node => node.type !== WorkflowNodeTypes.START);
    nodes.push(globalNode);

    const greetNode = createNode(startNodeBlueprint);
    greetNode.data.settings["scripted_greeting"] = scriptedGreeting;

    nodes.push(greetNode);

    const greetEdge = {
      id: `${globalNode.id}->${greetNode.id}`,
      source: globalNode.id,
      target: greetNode.id,
      type: "workflow",
    };

    const startEdges = edges.filter(edge => edge.source === startNode.id);

    startEdges.forEach(edge => {
      edge.source = greetNode.id;
      edge.id = `${greetNode.id}->${edge.target}`;
    });

    edges.push(...startEdges);
    edges.push(greetEdge);
  }

  return {nodes, edges};
};

// Versions
const versions = [
  {
    version: 1,
    apply: migration_1,
  },
];

// Apply migrations
export const applyFlowMigration = async (
  flowData: any,
  syncActions: boolean = false,
) => {
  const version = flowData?.version;
  if (!version && version !== 0) return flowData;

  const updatedFlowData = flowData || {};

  for (let i = version; i < versions.length; i++) {
    const nodes = updatedFlowData.nodes;
    const edges = updatedFlowData.edges;

    const {nodes: updatedNodes, edges: updatedEdges} = versions[i].apply(
      nodes,
      edges,
    );

    // Cleanup duplicate ids from nodes and edges
    updatedFlowData.nodes = cleanDuplicateIds(updatedNodes);
    updatedFlowData.edges = cleanDuplicateIds(updatedEdges);
    updatedFlowData.version = versions[i].version;
  }

  if (syncActions) {
    updatedFlowData.nodes = await syncNodeActions(updatedFlowData.nodes);
  }

  return updatedFlowData;
};

export const LATEST_FLOW_DATA_VERSION = versions[versions.length - 1].version;
